<template lang="pug">
  div
    top-nav(headerColor="white")
    .placeholder(v-if="loading")
    transition(name='fade')
      .content.article(v-if="!loading")
        .grid
          .col-4_xs-12.titles
            h2.h-l
              | learn
            router-link(:to="{ name: 'blog'}")
              h3.h-sm.category
                | 600state
            h1.h-xl
              | {{ title }}
            .author-date
              h4.h-md.author
                | {{ author }}
              h4.h-md.date
                | {{ date }}
            h4.h-sm.share(@click="share=!share")
              | share
              transition(name='fade')
                social(v-if="share" :meta="shareInfo")
          .col-8_xs-12
            .hero
              img.cover(:src="hero.url" :alt="heroCaption")
            p.heroCaptions.body-captions(v-if="captions" v-html="captions")
          .col-5_xs-12(data-push-left="off-4_xs-0" v-if="hero.url")
            .copy.wysiwyg(v-html="text")
    bottom-nav(footerColor="white")
</template>

<script>
import DataMixin from '@/mixins/DataMixin'
import ComponentMixin from '@/mixins/ComponentMixin'

export default {
  name: 'article',
  mixins: [DataMixin, ComponentMixin],

  data () {
    return {
      share: false
    }
  },

  created () {
    this.requestData(this.key, 'article')
  },

  methods: {
  },

  computed: {
    key: function () {
      return this.$route.path.substring(1)
    },

    content: function () {
      return this.loadedData[this.key].content
    },

    files: function () {
      return this.loadedData[this.key].files
    },

    title: function () {
      return this.content.title
    },

    hero: function () {
      const name = this.content.main_image
      return this.files.find(item => item.filename === name)
    },

    heroCaption: function () {
      return this.hero.meta.caption
    },

    captions: function () {
      let captionString = ''
      if (this.hero) {
        const caption = this.hero.meta.caption
        const credit = this.hero.meta.credit

        if (caption) {
          captionString += caption + '. '
        }
        if (credit) {
          captionString += credit + '.'
        }

        return captionString
      } else {
        return false
      }
    },

    text: function () {
      return this.content.text
    },

    author: function () {
      return this.content.author
    },

    date: function () {
      return this.content.date
    },

    shareInfo: function () {
      const data = {
        url: this.loadedData[this.key].url,
        title: this.title,
        description: this.text,
        image: this.hero.url
      }
      return data
    }
  },

  watch: {
    $route: function () {
      this.requestData(this.key)
    }
  }
}
</script>

<style lang="sass">
  @import '../styles/_mixins'
  @import '../styles/_variables'
  .article
    padding-top: 14rem
    @include respond-to(xs)
      padding-top: 0rem
    .titles
      margin-top: 14rem
      @include respond-to(xs)
        margin-top: 0rem
      h1
        padding-top: 4rem
        @include respond-to(xs)
          padding-top: 2rem
      ul
        margin-top: 4rem
        @include respond-to(xs)
          margin-top: 0rem
      h3
        color: rgb(104, 204, 232)
        margin-bottom: 0.5rem
      .author-date
        margin-top: 2.5rem
      .share
        margin-top: 2rem
        cursor: pointer
        color: #939598
    .hero
      width: 100%
      height: 47.5vw
      @include respond-to(xs)
        height: 72vw
    .heroCaptions
      margin-top: 1rem
      color: #939598
</style>



// WEBPACK FOOTER //
// Article.vue?51a3a2e4